import * as React from 'react';
export const HTSvg = React.forwardRef(function HTSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.994 2A1.998 1.998 0 0 0 0 3.998V8h16V3.998A1.997 1.997 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 8v4.002C0 13.106.895 14 1.994 14h12.012A1.998 1.998 0 0 0 16 12.002V8H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M4 6h8v4H4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M11.438 10H4.362c.86-.607 2.19-1 3.538-1 1.348 0 2.678.393 3.538 1ZM7 7h2v1l-.983 1L7 8V7Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M6 8h1v1H6V8Zm3 0h1v1H9V8ZM5 7h1v1H5V7Zm5 0h1v1h-1V7Z',
      }),
    ),
  );
});
HTSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var HT = {
  category: 'flag',
  colorable: false,
  name: 'HT',
  svg: HTSvg,
};
